"use strict";
import { useTranslation } from "uniswap/src/i18n";
export const useMenuContent = () => {
  const { t } = useTranslation();
  return [
    {
      title: "Help",
      items: [
        { label: "Deployed Contracts", href: "/deployments", internal: true },
        { label: "Brand Kit", href: "/brand-kit", internal: true },
        { label: "Contact Support", href: "https://swap-support.protofire.io/" }
      ]
    },
    {
      title: t("common.company"),
      items: [{ label: "Shape", href: "https://shape.network/" }]
    },
    {
      title: "Terms",
      items: [
        { label: "Terms and Conditions", href: "/terms" },
        { label: "Privacy Policy", href: "/privacy" }
      ]
    }
    // {
    //   title: t('common.protocol'),
    //   items: [
    //     { label: t('common.vote'), href: 'https://vote.uniswapfoundation.org' },
    //     { label: t('common.governance'), href: 'https://uniswap.org/governance' },
    //     { label: t('common.developers'), href: 'https://uniswap.org/developers' },
    //   ],
    // },
    // {
    //   title: t('common.needHelp'),
    //   items: [
    //     { label: t('common.helpCenter'), href: 'https://support.uniswap.org/hc/en-us' },
    //     { label: t('common.contactUs.button'), href: 'https://support.uniswap.org/hc/en-us/requests/new' },
    //   ],
    // },
  ];
};
